import { f as r } from "../internals/function-name.js";
import { d as t } from "../internals/define-built-in.js";
import { a as n } from "../internals/an-object.js";
import { t as s } from "../internals/to-string.js";
import { f as a } from "../internals/fails.js";
import { r as o } from "../internals/regexp-get-flags.js";
var e = r.PROPER,
  i = "toString",
  f = RegExp.prototype[i],
  m = a(function () {
    return "/a/b" != f.call({
      source: "a",
      flags: "b"
    });
  }),
  p = e && f.name != i;
(m || p) && t(RegExp.prototype, i, function () {
  var r = n(this);
  return "/" + s(r.source) + "/" + s(o(r));
}, {
  unsafe: !0
});